import type { PickAnalyticsEventAttributes } from '../../../../types'
import { analyticsEvents } from '../../integration/analytics-multiplatform-sdk'

export const FiltersShown = (attributes: PickAnalyticsEventAttributes<'FiltersShown'>) => {
  const { Filters } = analyticsEvents
  const { types, sortings, highlights, personalizedFilters, pricingFilters } = attributes

  return new Filters(types, sortings, highlights, personalizedFilters, pricingFilters)
}

export const FiltersApplied = (attributes: PickAnalyticsEventAttributes<'FiltersApplied'>) => {
  const { FiltersApplied } = analyticsEvents
  const {
    type,
    sortingId,
    prime,
    personalizedFilterType,
    origin,
    toggleValue,
    pricingId,
    personalizedFilterPosition,
    categoryId,
    newStoreWall,
    pageTemplate,
    filterOrigin,
    filters,
    searchId,
  } = attributes

  return new FiltersApplied(
    type,
    sortingId,
    prime,
    personalizedFilterType,
    origin,
    toggleValue,
    pricingId,
    personalizedFilterPosition,
    categoryId,
    newStoreWall,
    pageTemplate,
    filterOrigin,
    filters,
    searchId
  )
}

export const StoreAccessed = (attributes: PickAnalyticsEventAttributes<'StoreAccessed'>) => {
  const { StoreAccessed } = analyticsEvents
  const {
    storeAddressId,
    origin,
    operationType,
    isSponsored,
    promotionIds,
    promotionTypes,
    availabilityStatus,
    auctionId,
    storeId,
    userSelectedLanguage,
    filters,
    ncrRequestToken,
    shopId,
    shopPosition,
    userId,
    searchTerm,
    shopClickOrigin,
    shopSponsoring,
    shopSponsoringPlacement,
    screenName,
    swimlaneTitle,
    isFavorites,
    playlistIds,
    expeditionType,
    promoIds,
  } = attributes

  return new StoreAccessed(
    storeAddressId,
    origin,
    operationType,
    isSponsored,
    promotionIds,
    promotionTypes,
    availabilityStatus,
    auctionId,
    storeId,
    userSelectedLanguage,
    filters,
    ncrRequestToken,
    shopId,
    shopPosition,
    userId,
    searchTerm,
    shopClickOrigin,
    shopSponsoring,
    shopSponsoringPlacement,
    screenName,
    swimlaneTitle,
    isFavorites,
    playlistIds,
    expeditionType,
    promoIds
  )
}

export const StoreImpression = (attributes: PickAnalyticsEventAttributes<'StoreImpression'>) => {
  const { StoreImpression: StoreImpressionEvent } = analyticsEvents
  const {
    storeAddressId,
    isOpen,
    position,
    origin,
    deliveryFee,
    rating,
    numberOfRatedOrders,
    promotionIds,
    storeId,
    isPrime,
    etaLowerBound,
    etaUpperBound,
    sortingId,
    type,
    searchId,
    horizontalPosition,
    page,
    hasPicture,
    deliveryFeeCurrency,
    tags,
    isSponsored,
    searchProductMatches,
    searchProductImages,
    feesPricingCalculationId,
    rankingType,
    rankingScore,
    priceTag,
    isStoreSurged,
    titleBadge,
    inStorePrices,
    newStoreWall,
    availabilityStatus,
    filters,
    upgradeBanner,
    auctionId,
    impressionType,
    storeRankPosition,
    widgetHorizontalPosition,
    widgetVerticalPosition,
    ncrRequestToken,
    shopId,
    shopPosition,
    userId,
    searchTerm,
    shopSponsoring,
    shopSponsoringPlacement,
    screenName,
    impressionListName,
    swimlaneTitle,
    isFavorites,
    playlistIds,
    expeditionType,
    nestedStoreProductIds,
    promoIds,
    widgetId,
  } = attributes

  return new StoreImpressionEvent(
    storeAddressId,
    isOpen,
    position,
    origin,
    deliveryFee,
    rating,
    numberOfRatedOrders,
    promotionIds,
    storeId,
    isPrime,
    etaLowerBound,
    etaUpperBound,
    sortingId,
    type,
    searchId,
    horizontalPosition,
    page,
    hasPicture,
    deliveryFeeCurrency,
    tags,
    isSponsored,
    searchProductMatches,
    searchProductImages,
    feesPricingCalculationId,
    rankingType,
    rankingScore,
    priceTag,
    isStoreSurged,
    titleBadge,
    inStorePrices,
    newStoreWall,
    availabilityStatus,
    filters,
    upgradeBanner,
    auctionId,
    impressionType,
    storeRankPosition,
    widgetHorizontalPosition,
    widgetVerticalPosition,
    ncrRequestToken,
    shopId,
    shopPosition,
    userId,
    searchTerm,
    shopSponsoring,
    shopSponsoringPlacement,
    screenName,
    impressionListName,
    swimlaneTitle,
    isFavorites,
    playlistIds,
    expeditionType,
    nestedStoreProductIds,
    promoIds,
    widgetId
  )
}

export const StoresShown = (attributes: PickAnalyticsEventAttributes<'StoresShown'>) => {
  const { Stores } = analyticsEvents
  const {
    origin,
    storeAddressIds,
    storeIds,
    storeIdsCount,
    componentsLoaded,
    componentsPosition,
    rankingRequestId,
    isSurgeActivated,
    page,
    newStoreWall,
    isRefreshed,
    ncrRequestToken,
    shopsIds,
    playlistId,
  } = attributes

  return new Stores(
    origin,
    storeAddressIds,
    storeIds,
    storeIdsCount,
    componentsLoaded,
    componentsPosition,
    rankingRequestId,
    isSurgeActivated,
    page,
    newStoreWall,
    isRefreshed,
    ncrRequestToken,
    shopsIds,
    playlistId
  )
}
